import React from 'react';
import { Layout } from '../components/layout/Layout';
import { MinistryCard } from '../components/shared/MinistryCard';
import { Link } from 'react-router-dom';
import { HandHeart } from 'lucide-react';
import { ministriesData } from '../data/ministriesData';
export function MinistriesPage() {
  return <Layout data-id="element-869">
      {/* Header */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-870">
        <div className="absolute inset-0 opacity-20" data-id="element-871">
          <img src="https://images.unsplash.com/photo-1511649475669-e288648b2339?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Background" className="w-full h-full object-cover" data-id="element-872" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-873" />
        <div className="container-custom relative z-10" data-id="element-874">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4" data-id="element-875">
            Our Ministries
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-876">
            There's a place for everyone to connect, serve, and grow.
          </p>
        </div>
      </div>

      {/* Ministries Grid */}
      <section className="py-24 bg-[#F5F7FA]" data-id="element-877">
        <div className="container-custom" data-id="element-878">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-879">
            {ministriesData.map(ministry => {
            const Icon = ministry.icon;
            return <MinistryCard key={ministry.id} title={ministry.title} description={ministry.description} image={ministry.image} icon={<Icon className="w-6 h-6" data-id="element-881" />} link={`/ministries/${ministry.id}`} data-id="element-880" />;
          })}
          </div>
        </div>
      </section>

      {/* Volunteer CTA */}
      <section className="py-20 bg-white" data-id="element-882">
        <div className="container-custom text-center" data-id="element-883">
          <div className="max-w-3xl mx-auto bg-[#F5F7FA] p-10 rounded-2xl border border-[#C8102E]/20" data-id="element-884">
            <HandHeart className="w-12 h-12 text-[#C8102E] mx-auto mb-6" data-id="element-885" />
            <h2 className="text-3xl font-serif font-bold text-[#0A1F44] mb-4" data-id="element-886">
              Want to Serve?
            </h2>
            <p className="text-gray-600 mb-8 text-lg" data-id="element-887">
              God has given each of us unique gifts to build up the church. If
              you're interested in volunteering in any of these ministries, we'd
              love to help you find your spot.
            </p>
            <Link to="/join-team" data-id="element-888">
              <button className="bg-[#0A1F44] text-white px-8 py-3 rounded-md font-medium hover:bg-[#081833] transition-colors" data-id="element-889">
                Join a Team
              </button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}